<script lang="ts">
  import ImageCropper from "$app/components/ImageCropper.svelte"
  import { toast, xhr } from "$app/utils"
  import Honeybadger from "$app/utils/honeybadger"
  import { appStore } from "$app/store.svelte"

  interface Props {
    statement: StatementType
    onupdate: (statement: StatementType) => void
    oncancel: () => void
  }
  let props = $props()
  let { onupdate, oncancel }: Props = props
  let statement: any = $state(props.statement)

  let form = $state({ name: "" })
  let errors: any = $state({})
  let fileImage: any = $state(null)
  let image: any = $state(null)
  let openImgCropper = $state(false)
  let imageChanged = $state(false)
  let imageCropped = $state(false)
  let saving = $state(false)
  let fileInput: HTMLInputElement = $state(null)

  async function updateStatement(id: number): Promise<void> {
    saving = true

    try {
      const resp = await xhr.put<StatementType>(
        `/plans/${appStore.plan.id}/statements/${statement.id}.json?channel=${appStore.channel_id}`,
        {
          statement: {
            symbol_id: id
          }
        }
      )
      onupdate(resp.data)
    } catch (e) {
      if (typeof Honeybadger.notify !== "undefined") {
        Honeybadger.notify(e)
      }
      toast("There was an error updating", "error")
    } finally {
      saving = false
    }
  }

  async function uploadSymbol(): Promise<void> {
    saving = true
    errors = {}
    const formData = new FormData()
    formData.append("plan_symbol[name]", form.name)
    formData.append("plan_symbol[image]", fileImage)
    try {
      const resp = await xhr.post<PlanSymbolType>(
        `/plans/${appStore.plan.id}/symbols`,
        formData
      )

      updateStatement(resp.data.id)
    } catch (e: any) {
      if (e.response.data) {
        errors = e.response.data.errors
      } else {
        if (typeof Honeybadger.notify !== "undefined") {
          Honeybadger.notify(e)
        }
      }
      toast("There was an error uploading the image", "error")
    } finally {
      saving = false
    }
  }

  /**
   *
   * @param e
   */
  function onFileSelected(e: any) {
    fileImage = e.target.files[0]
    const reader = new FileReader()
    reader.readAsDataURL(fileImage)
    reader.onload = (e) => {
      image = e.target.result
      openImgCropper = true
      imageChanged = true
    }
  }
</script>

<div>
  <h2 class="text-xl font-bold mb-4">Upload Image Symbol</h2>
  <input
    type="file"
    bind:this={fileInput}
    onchange={onFileSelected}
    accept=".jpg, .jpeg, .png"
    class="hidden"
  />

  <div class:error={!!errors?.name} class="input-cont">
    <input
      type="text"
      name="name"
      bind:value={form.name}
      placeholder="Name"
      class="w-full input"
    />

    <div class="msg">
      {errors?.name}
    </div>
  </div>
  <div class="flex justify-start">
    {#if openImgCropper}
      <ImageCropper
        {image}
        modal={false}
        open={openImgCropper}
        file={fileImage}
        cropShape="square"
        btnText="Crop Image"
        cropperClose={() => {
          openImgCropper = false
        }}
        imageCropped={(data) => {
          imageCropped = true
          image = data.image
          fileImage = data.file
        }}
      />
    {:else}
      <button
        onclick={() => {
          fileInput.click()
        }}
        class="bg-gray-200 cursor-pointer border mt-4 flex items-center flex-col justify-center"
        id="blank-image-selector"
        tabindex="0"
      >
        {#if image}
          <img src={image} alt="Symbol" />
        {:else}
          <div class="font-bold text-gray-500 w-full text-center">
            Click to select an image to upload
          </div>
          <div class="mt-4 text-gray-500 w-full text-center">
            Accepted file types: JPG, JPEG & PNG
          </div>
        {/if}
      </button>
    {/if}
  </div>
  <div class="mt-4 text-right">
    <button type="button" class="btn outline" onclick={oncancel}>
      Cancel
    </button>
    <button
      type="submit"
      class="btn primary"
      onclick={() => uploadSymbol()}
      disabled={!image || saving || !imageCropped}
      class:bg-indigo-600={image && !openImgCropper}
      class:bg-indigo-300={!image || saving}
    >
      Upload Symbol
    </button>
  </div>
</div>

<style>
  #blank-image-selector {
    width: 300px;
    height: 300px;
  }
</style>
